import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-plus', 'IconCirclePlus', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M9 12l6 0', key: 'svg-1' }],
  ['path', { d: 'M12 9l0 6', key: 'svg-2' }],
]);
